import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { SEVERITY } from '../../utils/Snackbar';
import { deleteStorage } from '../../utils/LocalStorage';
import { get, put } from '../../utils/Api';
import { useParams } from "react-router";
import { useNavigate } from "react-router";
import { emailEhValido } from '../../utils/Formatters';
import StaticHeader from '../../utils/StaticHeader';

import KeyboardIcon from '@mui/icons-material/Keyboard';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';

export const TIPOS_PAGINA_DE_SEGURANCA = {
  CADASTRAR_USUARIO: {
    titulo: 'Cadastrar Usuário',
    botao: 'Cadastrar',
    tipo: 'cadastrar-usuario',
  },
  REDEFINIR_SENHA: {
    titulo: 'Redefinir Senha',
    botao: 'Salvar Senha',
    tipo: 'redefinir-senha',
  },
  REDEFINIR_EMAIL: {
    titulo: 'Confirmação do E-Mail',
    botao: 'Validar E-Mail',
    tipo: 'redefinir-email',
  },
};

export default function PaginaSegurancaDialog({
  setLoading,
  handleMessage,
  version,
  mainError,
  setError,
  tipoPaginaSeguranca,
  changeUsuario
}) {
  const { uuid } = useParams();
  const navigate = useNavigate();

  const [paginaDeSeguranca, setPaginaDeSeguranca] = useState({
    usuario_uuid: '',
    usuario_email: '',
    usuario_nome: '',
    usuario_senha: '',
    usuario_senha_confirmar: '',
    pagina_de_seguranca_novo_email: '',
    pagina_de_seguranca_tipo: tipoPaginaSeguranca.tipo,
  });

  const [aviso,setAviso] = useState('alerta');
  const [avisoConfirmar,setAvisoConfirmar] = useState('alerta');

  const validarTamanhoSenha = (senha) => {
    return (senha.length < 5) ? 'alerta' : 'revisado';
  };

  const validarSenhaConfirmar = (senha,confirmar) => {
    if (confirmar.length === 0) {
      return 'alerta';
    } else if (confirmar !== senha) {
      return 'incompleto';
    } else {
      return 'revisado';
    }
  };

  const handleChange = (event) => {
    const {name, value} = event.target;

    if (name === 'usuario_senha') {
      setAviso(validarTamanhoSenha(value));
      setAvisoConfirmar(validarSenhaConfirmar(value,paginaDeSeguranca.usuario_senha_confirmar));
    }

    if (name === 'usuario_senha_confirmar') {
      setAvisoConfirmar(validarSenhaConfirmar(paginaDeSeguranca.usuario_senha,value));
    }

    setPaginaDeSeguranca((dados) => ({
      ...dados,
      [name]: value
    }));
  };

  const handleSalvar = (event) => {
    if (mainError) { return; }

    const tipo_cadastrar_usuario = (paginaDeSeguranca.pagina_de_seguranca_tipo === 'cadastrar-usuario');
    const tipo_redefinir_senha = (paginaDeSeguranca.pagina_de_seguranca_tipo === 'redefinir-senha');
    const tipo_redefinir_email = (paginaDeSeguranca.pagina_de_seguranca_tipo === 'redefinir-email');

    /* Cópia rasa */
    let paginaDeSegurancaLocal = { ...paginaDeSeguranca };
    let usuario_nome = paginaDeSegurancaLocal.usuario_nome;

    /* Validações */
    if (tipo_cadastrar_usuario) {
      /* Obter valores do submit */
      const data = new FormData(event.currentTarget);

      /* Valores do documento */
      usuario_nome = data.get('usuario_nome');
      paginaDeSegurancaLocal.usuario_nome = usuario_nome;


      if (paginaDeSegurancaLocal.usuario_nome === '') {
        handleMessage(
          'Nome do usuário inválido!',
          SEVERITY.WARNING.toString(),
          '',
          false
        );
        return;
      }
    }

    if (tipo_cadastrar_usuario || tipo_redefinir_senha) {
      if (aviso !== 'revisado') {
        handleMessage(
          'Senha menor que 5 caracteres!',
          SEVERITY.WARNING.toString(),
          '',
          false
        );
        return;
      }

      if (avisoConfirmar !== 'revisado') {
        handleMessage(
          'As senhas digitadas estão diferentes!',
          SEVERITY.WARNING.toString(),
          '',
          false
        );
        return;
      }
    }

    if (tipo_redefinir_email) {
      const email_valido = emailEhValido(paginaDeSegurancaLocal.pagina_de_seguranca_novo_email);

      if (!email_valido) {
        handleMessage(
          'Novo e-mail inválido!',
          SEVERITY.WARNING.toString(),
          '',
          false
        );
        return;
      }
    }
    /* Validações */

    /* Enviar página de segurança */
    setLoading(true);

    put(`api/pagina-de-seguranca/${paginaDeSegurancaLocal.pagina_de_seguranca_tipo}/${uuid}`,paginaDeSegurancaLocal,(json)=>{

      changeUsuario(json.usuario,json.session_token,()=>{
        setLoading(false);

        if (tipo_cadastrar_usuario) {
          handleMessage('Cadastro concluído com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
        }
        if (tipo_redefinir_senha) {
          handleMessage('Senha alterada com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
        }
        if (tipo_redefinir_email) {
          handleMessage('E-mail alterado com sucesso!',SEVERITY.SUCCESS.toString(),'',false);
        }

        setPaginaDeSeguranca(estadoAnterior => ({
          ...estadoAnterior,
          usuario_nome: usuario_nome
        }));
        window.location.href = '/';
      });

    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
    });
    /* Enviar página de segurança */
  };

  const exibirIcon = (variavel) => {
    return (variavel !== 'revisado') ? (
      <ErrorIcon
        fontSize="large"
        color={variavel}
        sx={{
          marginTop: '10px'
        }}/>
    ) : (
      <CheckCircleIcon
        fontSize="large"
        color={variavel}
        sx={{
          marginTop: '10px'
        }}
      />
    )
  };

  useEffect(()=>{
    if (mainError) { return; }

    if (
      (tipoPaginaSeguranca.tipo === 'cadastrar-usuario') ||
      (tipoPaginaSeguranca.tipo === 'redefinir-email')
    ) {
      deleteStorage();
    }

    setLoading(true);
    get(`api/pagina-de-seguranca/${tipoPaginaSeguranca.tipo}/${uuid}`,(json)=>{

      setPaginaDeSeguranca((dados) => ({
        ...dados,
        usuario_uuid: json.usuario_uuid,
        usuario_email: json.usuario_email,
        usuario_nome: json.usuario_nome,
        usuario_senha: '',
        usuario_senha_confirmar: '',
        pagina_de_seguranca_novo_email: json.pagina_de_seguranca_novo_email,
        pagina_de_seguranca_tipo: tipoPaginaSeguranca.tipo,
      }));

      setLoading(false);

    },(error,message,severity)=>{
      setLoading(false);
      handleMessage(message,severity,error,true);
    });

  },[]);

  return (
    <StaticHeader
      version={version}
      setLoading={setLoading}
      handleMessage={handleMessage}
      error={mainError}
      setError={setError}>
      <Dialog
        closeAfterTransition={false}
        open={true}
        onClose={()=>{}}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        role="alertdialog"
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          handleSalvar(event);
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ backgroundColor: '#1565c0', color: '#fff' }}>
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center', }}>
            <KeyboardIcon sx={{ display: 'flex' }} />
            <Typography component="span" sx={{ color: '#fff', fontSize: 20 }}>
              {tipoPaginaSeguranca.titulo}
            </Typography>
          </Stack>
        </DialogTitle>
        <DialogContent
          sx={{ width: { xs: 'auto', sm: 400 } }}>

          {
            (paginaDeSeguranca.pagina_de_seguranca_tipo === 'redefinir-email') ? (
              <Grid
                container
                spacing={1}
                sx={{
                  marginTop: 4,
                }}>

                <Grid item="true" size={12}>
                  <TextField
                    fullWidth
                    slotProps={{ inputLabel: { shrink: true } }}
                    id="usuario_email"
                    name="usuario_email"
                    label="E-mail do Usuário"
                    value={paginaDeSeguranca.pagina_de_seguranca_novo_email}
                    disabled
                  />
                </Grid>

                <Grid
                  item="true"
                  size={12}>
                  <Box
                   sx={{
                     backgroundColor: '#f5f5f5',
                     boxSizing: 'border-box',
                     color: 'rgba(0, 0, 0, 0.38)',
                     fontSize: '16px',
                     fontWeight: '400',
                     width: '100%',
                     borderRadius: '4px',
                     display: 'flex',
                     padding: '6px 14px 8px 14px',
                     border: '1px solid #C4C4C4',
                   }}>
                   {'Esta página serve para confirmar o seu pedido de alteração do e-mail. Clique em Validar E-mail para continuar.'}
                  </Box>
                </Grid>

              </Grid>
            ) : (
              <Grid
                container
                sx={{
                  marginTop: 4,
                }}>

                {
                  (tipoPaginaSeguranca.tipo === 'cadastrar-usuario') ? (
                    <>
                      <Grid item="true" size={12} sx={{ marginBottom: '24px' }}>
                        <TextField
                          fullWidth
                          slotProps={{ inputLabel: { shrink: true } }}
                          id="usuario_email"
                          name="usuario_email"
                          label="E-mail do Usuário"
                          value={paginaDeSeguranca.usuario_email}
                          disabled
                        />
                    </Grid>
                      <Grid item="true" size={12} sx={{ marginBottom: '24px' }}>
                        <TextField
                          fullWidth
                          required
                          slotProps={{ inputLabel: { shrink: true } }}
                          id="usuario_nome"
                          name="usuario_nome"
                          label="Nome do Usuário"
                          defaultValue={paginaDeSeguranca.usuario_nome}
                        />
                    </Grid>
                  </>
                  ) : (<></>)
                }

                <Grid item="true" size={10.5} sx={{ marginBottom: '24px' }}>
                  <TextField
                    fullWidth
                    required
                    slotProps={{ inputLabel: { shrink: true } }}
                    id="usuario_senha"
                    name="usuario_senha"
                    label="Senha"
                    value={paginaDeSeguranca.usuario_senha}
                    onChange={handleChange}
                    type="password"
                  />
                </Grid>

                <Grid item="true" size={1.5} sx={{ textAlign: 'right' }}>
                  {exibirIcon(aviso)}
                </Grid>

                <Grid item="true" size={10.5}>
                  <TextField
                    fullWidth
                    required
                    slotProps={{ inputLabel: { shrink: true } }}
                    id="usuario_senha_confirmar"
                    name="usuario_senha_confirmar"
                    label="Confirmar Senha"
                    value={paginaDeSeguranca.usuario_senha_confirmar}
                    onChange={handleChange}
                    type="password"
                  />
                </Grid>

                <Grid item="true" size={1.5} sx={{ textAlign: 'right' }}>
                  {exibirIcon(avisoConfirmar)}
                </Grid>

              </Grid>
            )
          }

        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            onClick={()=>{
              navigate(`/`);
            }}>
            Cancelar
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="success"
            startIcon={<CheckCircleIcon />}>
            {tipoPaginaSeguranca.botao}
          </Button>
        </DialogActions>
      </Dialog>
    </StaticHeader>
  );
}
